<template>
    <div class="box">
        <!--..右侧盒子..-->
        <div class="me_guanzhu">
            <div class="guanz_tit">
                <p style="color: #39bf3e;border-bottom: 3px solid #39BF3E;" class="guanz_tit_02">我的专家</p>
            </div>
            <!--...专家...-->
            <div class="guanz_02_box" v-loading="loading">
                <div class="guanz_02" v-if="pageData.length">
                    <div class="guanz_02_zhuanjia">
                        <ul class="zhuanjia">
                            <!--..循坏..-->
                            <li v-for="item in pageData" :key="item.id">
                                <div class="sh">
                                    <div class="z"><img :src="$util.img(item.image)" alt=""></div>
                                    <div class="y">
                                        <h2>{{item.name}}·{{item.title}} | <a :href="'/agricultural/expertdetails?id='+item.id">详情</a></h2>
                                        <p>{{item.unit}}</p>
                                    </div>
                                </div>
                                <div class="zh">
                                    <h2>{{item.askCount}} <span>咨询量</span></h2>
                                    <h2>{{item.answer_rate}}<span>回复率</span></h2>
                                </div>
                                <div class="xia">擅长：{{item.expert_in}}</div>
                                <a :href="'/agricultural/expertdetails?id='+item.id" class="btn">免费提问</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <!--...分页..-->
                <div class="pages" v-if="pageData.length">
                    <div class="Pagination Pagination_course"></div>
                     <!-- <div class="searchPage"> <span class="page-sum">共<strong class="allPage">{{pageCount}}</strong>页</span></div> -->
                </div>
                <div v-if="!loading && !pageData.length" style="text-align: center;margin-top: 20px;">您还没有关注专家哦</div>
            </div>
        </div>
    </div>
</template>

<script>

    import '@/assets/styles/css/common.css';
    import '@/assets/styles/css/me.css';
    import '@/assets/styles/js/jquery.pagination.js';
    import { expertMyPage } from '@/api/expert/expert';

    export default {
        name: "",
        components: {},
        data: () => {
            return {
                pageCount:0,
                page_size:6,
                page:1,
                pageData:[],
                loading:true,
            }
        },
        created() {
           this.getExpert();             
        },
        methods: {
            getExpert(){
                expertMyPage({
                    page_size: this.page_size,
                    page: this.page,
                }).then(res => {
                    if(res.code == 0) {
                        this.pageCount = res.data.page_count;
                        $(".Pagination").pagination(this.pageCount, {
                            callback: this.changePage
                        });
                        this.pageData = res.data.list;
                        this.loading = false;
                    }
                });
            },
            changePage(page_id) {
                this.loading = true;
                this.page = page_id + 1;
                expertMyPage({
                    page_size: this.page_size,
                    page: this.page,
                }).then(res => {
                    if(res.code == 0) {
                        this.pageData = res.data.list;
                        this.loading = false;
                    }
                });
            },
        },
        mounted() {
            
		},
    }
</script>